export default __webpack_public_path__ + "static/media/SP500-Cloud-396x400.abc8e2b2.gif";